<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0px;">Nick Zamfir is the founder and president of Abiding in Christ Ministries based in Orlando, Florida.</p><br/>
<p style="text-indent:0px;">Zamfir has a bachelor’s degree in theology from Babes-Bolyai University, Cluj-Napoca, Romania, and has a minor in marriage counselling. He and his wife, Doina, have been married for 33 years and have a 31-year-old son, Alin, and a 27-year-old daughter, Kristina. They have lived in the Orlando for the past 14 years.</p><br/>
<p style="text-indent:0px;">After accumulating writing experience as a religious columnist for a newspaper, Nick is now writing his fifth book. He also preaches, authors textbooks, and teaches in a school of ministry, and is in his final preparation for an Internet-based television ministry focused on positive, life-changing programs for youth and young adults, and for the non-professing Christian community.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1fe0a964